// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  const footerLinkProps = { target: '_blank', variant: 'caption', sx: { color: 'text.primary' } };
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">
        &copy; {new Date().getFullYear()} KambaTime GPO. Todos os direitos reservados.
      </Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="/payments" {...footerLinkProps}>
          Pagamentos
        </Link>
        <Link href="/webhooks" {...footerLinkProps}>
          Webhooks
        </Link>
        <Link href="/settings" {...footerLinkProps}>
          Definições
        </Link>
        <Link href="https://kambatime.com" {...footerLinkProps}>
          Suporte
        </Link>
      </Stack>
    </Stack>
  );
}
